import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { AppBar, Box, CircularProgress, Tab, Tabs } from "@mui/material";
import Form from "../../components/form";

export default function Dashboard() {
  const [dadosDash, setDadosDash] = useState("");
  useEffect(() => {
    carregarDash();
  }, []);

  const carregarDash = () => {
    api.get("dashboard/bilingue").then((dash) => {
      setDadosDash(dash);
    });
  };

  if (!dadosDash)
    return (
      <Box sx={{ textAlign: "center", display: "flex" }}>
        <CircularProgress />
      </Box>
    );

  const dados = {
    title: "Dashboard - Treinamentos",
    form: {
      totPeriodo: {
        label: "Total para o período",
        type: "text",
        readOnly: true,
        space: 4,
        value: dadosDash.acompanhamentos.qtdTotalPeriodo,
      },
      finalizados: {
        label: "Finalizados",
        type: "text",
        readOnly: true,
        space: 4,
        value:
          dadosDash.acompanhamentos.qtdFinalizados +
          " (" +
          dadosDash.acompanhamentos.pctFinalizados +
          "%)",
      },
      qtdDeveriamEstarEmAberto: {
        label: "Deveriam estar em aberto",
        type: "text",
        readOnly: true,
        space: 4,
        value:
          dadosDash.acompanhamentos.qtdDeveriamEstarEmAberto +
          " (" +
          dadosDash.acompanhamentos.pctDeveriamEstarEmAberto +
          "%)",
      },
      qtdEmAberto: {
        label: "Em aberto",
        type: "text",
        readOnly: true,
        space: 6,
        value:
          dadosDash.acompanhamentos.qtdEmAberto +
          " (" +
          dadosDash.acompanhamentos.pctEmAberto +
          "%)",
      },
      qtdNaoIniciados: {
        label: "Não iniciados",
        type: "text",
        readOnly: true,
        space: 6,
        value:
          dadosDash.acompanhamentos.qtdNaoIniciados +
          " (" +
          dadosDash.acompanhamentos.pctNaoIniciados +
          "%)",
      },

      qtdAtrasadoParaIniciar: {
        label: "Em atraso para iniciar",
        type: "text",
        readOnly: true,
        space: 4,
        value:
          dadosDash.acompanhamentos.qtdAtrasadoParaIniciar +
          " (" +
          dadosDash.acompanhamentos.pctAtrasadoParaIniciar +
          "%)",
      },
      qtdAguardandoRespostaProfMenos24h: {
        label: "Aguardando resposta do profissional (menos de 24h)",
        type: "text",
        readOnly: true,
        space: 4,
        value:
          dadosDash.acompanhamentos.qtdAguardandoRespostaProfMenos24h +
          " (" +
          dadosDash.acompanhamentos.pctAguardRespostaProfMenos24h +
          "%)",
      },
      qtdAguardandoRespostaProfMais24h: {
        label: "Aguardando resposta do profissional (mais de 24h)",
        type: "text",
        readOnly: true,
        space: 4,
        value:
          dadosDash.acompanhamentos.qtdAguardandoRespostaProfMais24h +
          " (" +
          dadosDash.acompanhamentos.pctAguardRespostaProfMais24h +
          "%)",
      },
      aguardandoFeedbackPerto: {
        label: "Aguardando feedback da Perto",
        type: "text",
        readOnly: true,
        space: 4,
        value:
          dadosDash.acompanhamentos.qtdAguardandoRespostaPerto +
          " (" +
          dadosDash.acompanhamentos.pctAguardandoRespostaPerto +
          "%)",
      },
      aguardandoFeedbackPertoMenos24h: {
        label: "Aguardando feedback da Perto (menos de 24h)",
        type: "text",
        readOnly: true,
        space: 4,
        value:
          dadosDash.acompanhamentos.qtdAguardandoRespostaPertoMenos24h +
          " (" +
          dadosDash.acompanhamentos.pctAguardRespostaPertoMenos24h +
          "%)",
      },
      aguardandoFeedbackPertoMais24h: {
        label: "Aguardando feedback da Perto (mais de 24h)",
        type: "text",
        readOnly: true,
        space: 4,
        value:
          dadosDash.acompanhamentos.qtdAguardandoRespostaPertoMais24h +
          " (" +
          dadosDash.acompanhamentos.pctAguardRespostaertoMais24h +
          "%)",
      },
      qtdRegentesAtivos: {
        label: "Regentes ativos",
        type: "text",
        readOnly: true,
        space: 4,
        value: dadosDash.indicadores.qtdTotal,
      },
      participacao: {
        label: "Regentes ativos",
        type: "text",
        readOnly: true,
        space: 4,
        value: dadosDash.indicadores.participacao + "%",
      },
    },
  };

  return (
    <div>
      <Form formData={dados} />
    </div>
  );
}
